let main_productElm = document.querySelector('.meta_productsMain')

if(main_productElm){
  new Splide(main_productElm, {
    type: 'slide',
    perPage: 3,
    arrows: true,
    pagination: false,
    gap: '1rem',
    breakpoints: {
      1200: {
        perPage:2 ,
        pagination: true,
        arrows: false,
      }
    }
  }).mount();
}

// Read More/Read Less metafield content
document.addEventListener("DOMContentLoaded", function () {
  var specEl = document.querySelector(".meta_specification.RRRR ul");

  if (specEl) {
    var text = specEl.innerText || specEl.textContent;
    var charCount = text.trim().length;

    if (charCount > 200) {
      // Set initial styles
      specEl.style.overflow = "hidden";
      specEl.style.transition = "max-height 0.4s ease";
      specEl.style.maxHeight = "130px";

      // Create the toggle button
      var toggleBtn = document.createElement("button");
      toggleBtn.classList.add("toggle_btn");
      toggleBtn.innerText = "Read More";
      toggleBtn.setAttribute("type", "button");
      toggleBtn.style.marginTop = "10px";
      toggleBtn.style.display = "inline-block";

      specEl.insertAdjacentElement("afterend", toggleBtn);

      let expanded = false;

      toggleBtn.addEventListener("click", function () {
        if (!expanded) {
          // Expand smoothly
          specEl.style.maxHeight = specEl.scrollHeight + "px";
          toggleBtn.innerText = "Read Less";
        } else {
          // Collapse smoothly
          specEl.style.maxHeight = "130px";
          toggleBtn.innerText = "Read More";
        }
        expanded = !expanded;
      });
    }
  }
});
// Read More/Read Less metafield content

